<template>
	<v-container fluid
		ref="container"
		class="fill-height py-0 align-start sidebar-container grey--text text--darken-2" style="height: 100%;">
		<v-row>
			<v-col class="pa-0 mt-0 fill-height">
				<div class="d-flex align-center justify-center text-center mb-4" v-if="$vuetify.breakpoint.mobile">
					<v-img
						:src="require('../../assets/imgs/logo-top.svg')"
						contain
						height="100"
						width="100"
					/>
					<v-btn
						icon
						color="#707070"
						@click="$store.commit('setDrawerState', false)"
						style="position: absolute; top: 20px; right: 20px;"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</div>
				<div class="d-flex align-center pa-0" ref="topContainer">
					<div class="d-flex align-center px-4 py-5">
						<v-avatar
							size="70">
							<v-img
								v-if="this.$store.state.userData && this.$store.state.userData.info && this.$store.state.userData.info.avatar"
								:src="$store.state.userData.info.avatar"
								width="70"
								height="70"
							>
								<template v-slot:placeholder>
									<v-row
										class="fill-height ma-0"
										align="center"
										justify="center"
									>
										<v-progress-circular
											indeterminate
											color="grey lighten-5"
										></v-progress-circular>
									</v-row>
								</template>
							</v-img>
							<span
								v-else
								style="width: 70px; height: 70px;line-height: 70px;"
								class="rounded-circle background-sosclick white--text headline">
								{{this.$store.state.userData ? this.$store.state.userData.name.match(/\b(\w)/g).join(''):''}}
							</span>
						</v-avatar>
						<div class="px-2">
							<p class="mb-0 subtitle-2 ">{{this.$store.state.userData ? this.$store.state.userData.name:''}}</p>
							<a class="pa-0 ma-0 textcolor-sosclick subtitle-2 font-weight-regular"
								@click="editProfile()">Editar Perfil</a>
						</div>
					</div>
				</div>
				<v-divider style="border-color: #707070;"></v-divider>
				<div class="d-flex flex-column" :style="{'max-height': height + 'px'}">
					<p class="mb-0 text-center body-2 font-weight-medium py-3">Dispositivos registrados</p>
					<div class="fill-height" v-if="this.$store.state.userData && this.$store.state.userData.dispositivos" style="max-height: 100%;overflow-y: scroll;border-top: 1px solid #707070;">
						<div :key="index" v-for="(item, index) in this.$store.state.userData.dispositivos">
							<v-btn depressed large tile block
								class="d-flex text-white py-5 px-5 container-device-sidebar"
								:class="$store.state.selectedDevice && $store.state.selectedDevice.id === item.id ? 'selected':''"
								@click="selectDevice(item)"
								style="height: auto;">
								<v-icon
									large
									class="my-2 mr-2 custom-icon-button-sidebar"
								>
									mdi-cellphone
								</v-icon>
								<v-divider class="custom-divider-button-sidebar" vertical></v-divider>
								<div class="text-container text-left">
									<p class="text-capitalize mb-0 ml-2 font-weight-regular custom-text-button-sidebar">{{item.device_brand}} {{item.device_name}}</p>
									<p class="text-capitalize mb-0 ml-2 font-weight-regular custom-text-button-sidebar">{{item.device_model}}</p>
								</div>
							</v-btn>
						</div>
					</div>
					<div class="mb-0 text-center body-2 py-3" v-else>
						No hay dispositivos registrados en tu cuenta
					</div>
				</div>
				<!-- <div class="py-4 px-7">
					<p class="mb-0 caption font-weight-bold">Activar Perdida Teléfono</p>
					<p class="caption">Puedes activar esta funcionalidad si perdiste o si te robaron tu teléfono.</p>
					<p class="caption">Si asignaste la opción <b>“Mostrar sobre otras Apps”</b> a la app SOSclick, podremos enviarte periódicamente 2 fotografías (una de la cámara frontal y otra de la trasera) y la ubicación a tu correo. Si no asignaste esa opción sólo podremos enviarte la ubicación.</p>
				</div> -->
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
	import {getUser} from '../../helpers/api/user'
	export default {
		name: 'SidebarContent',
		components: {},
		data: () => ({
			height: 200
		}),
		mounted () {
			this.getUserData()
			this.height = this.$refs.container.clientHeight - this.$refs.topContainer.clientHeight - 1 //1 por el borde
		},
		methods: {
			editProfile(){
				this.$store.commit('setModalsStates', {editProfile: true})
				this.$store.commit('setDrawerState', false)
			},
			selectDevice(item){
				this.$store.commit('setSelectedDevice', item)
				this.$store.commit('setDrawerState', false)
			},
			async getUserData () {
				if (!this.$store.state.userData) {
					await getUser()
				}
			},
		}
	};
</script>
